import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Checkbox,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getIndustryChains,
  getIndustryChainBelongs,
  getInsuranceInstitutions,
  getInsuranceProducts,
  addInsuranceFinancing,
} from '@/services/supplyChainFinance';
import AuthorizationInfo from '@/components/FormInfo/AuthorizationInfo';
import './index.less';

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

export default function Application() {
  const [form] = Form.useForm();
  const Navigate = useNavigate();
  const { userType } = useSelector((state) => state);
  const user = useSelector((state) => state.userInfo);
  const [authInfoModal, setAuthInfoModal] = useState(false); // 授权协议内容
  const [industryChainList, setIndustryChainList] = useState([]); // 产业链列表
  const [projectList, setProjectList] = useState([]); // 项目列表
  const [institutionList, setInstitutionList] = useState([]); // 保险机构列表
  const [productList, setProductList] = useState([]); // 保险产品列表
  const [industryChainDisabled, setIndustryChainDisabled] = useState(false); // 产业链Select是否禁用
  const [projectNameDisabled, setProjectNameDisabled] = useState(false); // 项目名称Select是否禁用
  const [showProductCard, setShowProductCard] = useState(false); // 是否显示保险产品信息Card
  const [selectedProductInfo, setSelectedProductInfo] = useState({}); // 选中的产品详情
  const [pageLoading, setPageLoading] = useState(false); // 页面加载状态

  const { loading: submitLoading, run: submitRun } = useRequest(addInsuranceFinancing, {
    manual: true,
    onSuccess() {
      Navigate('/result');
    },
  });

  // 处理保险机构选择变化
  const handleInstitutionChange = async (institutionId) => {
    // 清空产品列表和产品名称
    setProductList([]);
    setShowProductCard(false);
    setSelectedProductInfo({});
    form.setFieldsValue({ productName: undefined });

    if (institutionId) {
      try {
        // 获取项目名称对象
        const projectId = form.getFieldValue('billionAgriProjectId');
        // 获取产品列表
        const products = await getInsuranceProducts(institutionId, projectId);
        if (products && products.length > 0) {
          const productOptions = products.map((item) => ({
            label: item.productName,
            value: item.id,
            productName: item.productName,
            id: item.id,
            name: item.name,
            orgType: item.orgType,
            orgAmount: item.orgAmount,
            orgRate: item.orgRate,
            orgTel: item.orgTel,
            content: item.content,
            content1: item.content1,
            content2: item.content2,
            content3: item.content3,
            content4: item.content4,
          }));
          setProductList(productOptions);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('获取保险产品列表失败:', error);
      }
    }
  };

  // 处理产品选择变化
  const handleProductChange = (productId) => {
    // 根据选中的产品ID找到对应的产品详情
    const selectedProduct = productList.find((item) => item.id === productId);
    if (selectedProduct) {
      setSelectedProductInfo(selectedProduct);
      setShowProductCard(true);
    }
  };

  function onFinish(values) {
    // 根据 billionAgriProjectId 找到对应的项目名称
    const selectedProject = projectList.find(
      (project) => project.billionAgriProjectId === values.billionAgriProjectId,
    );
    const projectName = selectedProject ? selectedProject.projectName : '';

    // 根据 insuranceInstitution 找到对应的机构名称
    const selectedInstitution = institutionList.find(
      (institution) => institution.value === values.insuranceInstitution,
    );
    const institutionName = selectedInstitution ? selectedInstitution.orgName : '';
    const orgId = selectedInstitution ? selectedInstitution.value : '';

    // 根据产品名称找到对应的产品详情
    const selectedProduct = productList.find(
      (product) => product.value === values.productName,
    );
    const productName = selectedProduct ? selectedProduct.productName : '';
    const productId = selectedProduct ? selectedProduct.id : '';
    const content = selectedProduct ? selectedProduct.content : '';

    const obj = {
      ...values,
      applicantId: user.id,
      applicantName: userType === 2 ? user.realName : user.displayName,
      applicantNo: userType === 2 ? user.idcardNo : user.displayCode,
      projectName,
      orgId,
      orgName: institutionName,
      productName,
      productId,
      content,
    };
    submitRun(obj);
  }

  function checkAuthorize(_, value) {
    if (!value) {
      return Promise.reject(new Error('请勾选同意并接受'));
    }
    return Promise.resolve();
  }

  // 处理项目名称变化
  const handleProjectChange = async (projectId) => {
    if (projectId) {
      try {
        // 清空保险机构和产品列表
        setInstitutionList([]);
        setProductList([]);
        setShowProductCard(false);
        setSelectedProductInfo({});
        form.setFieldsValue({
          insuranceInstitution: undefined,
          productName: undefined,
        });

        // 获取保险机构列表
        const institutions = await getInsuranceInstitutions(projectId);
        if (institutions && institutions.length > 0) {
          const institutionOptions = institutions.map((item) => ({
            label: item.orgName,
            value: item.orgId,
            orgName: item.orgName,
            orgId: item.orgId,
          }));
          setInstitutionList(institutionOptions);

          // 如果只有一个机构，自动选中但不禁用
          if (institutions.length === 1) {
            const { orgId } = institutions[0];
            form.setFieldsValue({
              insuranceInstitution: orgId,
            });
            // 自动加载该机构的产品列表
            await handleInstitutionChange(orgId);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('获取保险机构列表失败:', error);
      }
    } else {
      // 清空保险机构和产品列表
      setInstitutionList([]);
      setProductList([]);
      setShowProductCard(false);
      setSelectedProductInfo({});
      form.setFieldsValue({
        insuranceInstitution: undefined,
        productName: undefined,
      });
    }
  };

  // 根据产业链加载项目列表
  const loadProjectsByIndustryChain = async (industryChainBelongs) => {
    try {
      // 获取该产业链对应的项目列表
      const projects = await getIndustryChainBelongs(industryChainBelongs);

      if (projects && projects.length > 0) {
        const projectOptions = projects.map((item) => ({
          label: item.projectName,
          value: item.billionAgriProjectId,
          projectName: item.projectName,
          billionAgriProjectId: item.billionAgriProjectId,
        }));
        setProjectList(projectOptions);

        // 如果只有一个项目，自动选中并禁用
        if (projects.length === 1) {
          setProjectNameDisabled(true);
          const projectId = projects[0].billionAgriProjectId;
          form.setFieldsValue({
            billionAgriProjectId: projectId,
          });
          // 自动加载该项目的保险机构列表
          await handleProjectChange(projectId);
        } else {
          // 如果有多个项目，启用选择
          setProjectNameDisabled(false);
        }
      } else {
        setProjectList([]);
        setProjectNameDisabled(false);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('加载项目列表失败:', error);
      setProjectList([]);
      setProjectNameDisabled(false);
    }
  };

  // 加载产业链列表
  const loadIndustryChains = async () => {
    try {
      setPageLoading(true);
      // 获取产业链列表
      const industryChains = await getIndustryChains();

      if (industryChains && industryChains.length > 0) {
        // 处理产业链列表
        const chainOptions = industryChains.map((item) => ({
          label: item.industryChainBelongs,
          value: item.industryChainBelongs,
        }));
        setIndustryChainList(chainOptions);

        // 如果只有一个产业链，自动选中并禁用，并自动加载项目列表
        if (industryChains.length === 1) {
          setIndustryChainDisabled(true);
          const industryChain = industryChains[0].industryChainBelongs;
          form.setFieldsValue({
            industryChainBelongs: industryChain,
          });
          // 自动加载该产业链的项目列表
          await loadProjectsByIndustryChain(industryChain);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('加载产业链列表失败:', error);
    } finally {
      setPageLoading(false);
    }
  };

  // 处理所属产业链变化
  const handleIndustryChainChange = async (industryChainBelongs) => {
    // 清空项目名称、保险机构和产品列表
    form.setFieldsValue({
      billionAgriProjectId: undefined,
      insuranceInstitution: undefined,
      productName: undefined,
    });
    setProjectList([]);
    setInstitutionList([]);
    setProductList([]);
    setShowProductCard(false);
    setSelectedProductInfo({});
    setProjectNameDisabled(false);

    if (industryChainBelongs) {
      await loadProjectsByIndustryChain(industryChainBelongs);
    }
  };

  // 页面加载时获取数据
  useEffect(() => {
    loadIndustryChains();
  }, []);

  return (
    <div className="supply-chain-finance__info">
      <div className="content-width">
        <div className="supply-chain-finance__info-title">保险申请</div>
        <div className="margin-top20">
          <Spin spinning={pageLoading}>
            <Form
              {...formItemLayout}
              form={form}
              name="form"
              className="form"
              onFinish={onFinish}
            >
              <Card title="保险需求" className="form-info__box">
                <Row>
                  <Col span={12}>
                    <Form.Item
                      name="industryChainBelongs"
                      label="所属产业链"
                      rules={[
                        { required: true, message: '请选择所属产业链' },
                      ]}
                    >
                      <Select
                        placeholder="请选择所属产业链"
                        options={industryChainList}
                        disabled={industryChainDisabled}
                        onChange={handleIndustryChainChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="billionAgriProjectId"
                      label="项目名称"
                      rules={[
                        { required: true, message: '请选择项目名称' },
                      ]}
                    >
                      <Select
                        placeholder="请选择项目名称"
                        options={projectList}
                        disabled={projectNameDisabled}
                        onChange={handleProjectChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="insuranceInstitution"
                      label="申请保险机构"
                      rules={[
                        { required: true, message: '请选择申请保险机构' },
                      ]}
                    >
                      <Select
                        placeholder="请选择申请保险机构"
                        options={institutionList}
                        onChange={handleInstitutionChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="productName"
                      label="产品名称"
                      rules={[
                        { required: true, message: '请选择产品名称' },
                      ]}
                    >
                      <Select
                        placeholder="请选择产品名称"
                        options={productList}
                        onChange={handleProductChange}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              {showProductCard && (
                <Card title="保险产品信息" className="form-info__box" style={{ marginTop: 24 }}>
                  <Row>
                    <Col span={12}>
                      <div className="product-info-item">
                        <span className="product-info-label">产品名称：</span>
                        <span>{selectedProductInfo?.productName || '-'}</span>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="product-info-item">
                        <span className="product-info-label">保险机构：</span>
                        <span>{selectedProductInfo?.name || '-'}</span>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="product-info-item">
                        <span className="product-info-label">保险类型：</span>
                        <span>{selectedProductInfo?.orgType || '-'}</span>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="product-info-item">
                        <span className="product-info-label">单位保险金额：</span>
                        <span>{selectedProductInfo?.orgAmount || '-'}</span>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="product-info-item">
                        <span className="product-info-label">保险费率：</span>
                        <span>{selectedProductInfo?.orgRate || '-'}</span>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="product-info-item">
                        <span className="product-info-label">联系方式：</span>
                        <span>{selectedProductInfo?.orgTel || '-'}</span>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="product-info-item">
                        <span className="product-info-label">产品介绍：</span>
                        <div dangerouslySetInnerHTML={{ __html: selectedProductInfo?.content }} />
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="product-info-item">
                        <span className="product-info-label">保险责任：</span>
                        <div dangerouslySetInnerHTML={{ __html: selectedProductInfo?.content1 }} />
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="product-info-item">
                        <span className="product-info-label">投保条件：</span>
                        <div dangerouslySetInnerHTML={{ __html: selectedProductInfo?.content2 }} />
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="product-info-item">
                        <span className="product-info-label">理赔流程：</span>
                        <div dangerouslySetInnerHTML={{ __html: selectedProductInfo?.content3 }} />
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="product-info-item">
                        <span className="product-info-label">其他：</span>
                        <div dangerouslySetInnerHTML={{ __html: selectedProductInfo?.content4 }} />
                      </div>
                    </Col>
                  </Row>
                </Card>
              )}
              <div className="authorize">
                <Form.Item
                  required
                  name="authorize"
                  wrapperCol={{ span: 24 }}
                  valuePropName="checked"
                  rules={[
                    { validator: checkAuthorize },
                  ]}
                >
                  <Checkbox
                    onChange={(e) => {
                      form.setFieldsValue({ authorize: false });
                      if (e.target.checked) {
                        setAuthInfoModal(true);
                      }
                    }}
                  >
                    您需要同意并接受
                    <Button type="link" className="authorize-name" onClick={() => setAuthInfoModal(true)}>《直通车平台业务授权协议》</Button>
                  </Checkbox>
                </Form.Item>
              </div>
              <div className="submit-btn-box">
                <Button type="primary" htmlType="submit" loading={submitLoading}>
                  提交申请
                </Button>
              </div>
            </Form>
          </Spin>
          <Modal
            title="授权协议查看"
            open={authInfoModal}
            width={900}
            footer={
              [
                <Button key="skip" onClick={() => setAuthInfoModal(false)}>
                  取消
                </Button>,
                <Button
                  type="primary"
                  key="confirm"
                  onClick={() => {
                    setAuthInfoModal(false);
                    form.setFieldsValue({ authorize: true });
                  }}
                >
                  确认
                </Button>,
              ]
            }
            onCancel={() => setAuthInfoModal(false)}
          >
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: AuthorizationInfo }} style={{ maxHeight: 600, overflowY: 'scroll' }} />
          </Modal>
        </div>
      </div>
    </div>
  );
}
